module.exports = __webpack_public_path__ + "prod/1.42.2/media/banner.0bc75ba0.mp4";